module.exports = __webpack_public_path__ + "static/media/logo163.09f364ea.png";